import type { CreateApiKeyBodyType, CreatedCredentialBodyType, GetApiKeyType, PublicApiScope } from "@whatslly/types/integrations/api-keys/ApiKey";
import { TFunction } from "i18next";
import { IPromiseBasedObservable } from "mobx-utils";

export const IApiKeysStore = Symbol.for("IApiKeysStore");

export type CredentialType = CreatedCredentialBodyType["type"];
export type CredentialAuthMethod = NonNullable<CreateApiKeyBodyType["authMethod"]>;

export type CreateCredentialParams = {
  apiKeyName: string;
  scopes?: PublicApiScope[];
  type: CredentialType;
  authMethod?: CredentialAuthMethod;
  certPem?: string;
  t: TFunction;
};

export interface IApiKeysStore {
  createdCredential: CreatedCredentialBodyType | undefined;
  keys: IPromiseBasedObservable<GetApiKeyType[]>;
  baseUrl: IPromiseBasedObservable<string>;
  loading: boolean;
  keysUpdating: boolean;
  refresh(): void;
  reset(): void;
  createCredential(params: CreateCredentialParams): Promise<CreatedCredentialBodyType | undefined>;
  updateScopes(params: { apiKey: string; scopes: PublicApiScope[]; t: TFunction }): Promise<boolean>;
  revokeApiKey(params: { apiKey: string; t: TFunction }): Promise<void>;
}
